import { Container, Col} from 'react-bootstrap';
import React, { useState, useEffect } from 'react'

const HomeImages = () => {

    const prompts = [
        "Welcome to Cranbury Commons!",
        "Food, Convenience, and Comfort",
        "Community at Your Doorstep",
        "Local favorites under one roof"
      ];
    
      const [index, setIndex] = useState(0);
      const [key, setKey] = useState(0); 
    
      useEffect(() => {
        const interval = setInterval(() => {
          setIndex((prevIndex) => (prevIndex + 1) % prompts.length);
          setKey((prevKey) => prevKey + 1);
        }, 10000); 
    
        return () => clearInterval(interval);
      }, [prompts.length]);

    return (
        <Container className = "d-flex justify-content-center align-items-center p-0 w-100 homeImagesContainer" fluid>
            <Col className='6'>
            <img src='./images/homeImages/image1.jpg' alt="Cranbury Commons Image1" className="homeImage" />
            </Col>
            <Col className='6'>
            <img src='./images/homeImages/image2.jpg' alt="Cranbury Commons Image2" className="homeImage" />
            </Col>
            <Container className='imageOverlayContainer'>
            <p key={key} className="textOverlayText">
                {prompts[index]}
            </p>
            </Container>
        </Container>
    );
};

export default HomeImages;
